export default __webpack_public_path__ + "static/media/Bk.560c2965.svg";